
import { MaterialSymbol } from "@material-symbols/font-400";

export interface IMenuItem {
  id: number;
  name: string;
  icon: MaterialSymbol;
  path: string;
  isVisible: boolean;
  isActivated: boolean;
  /** Only shown to investors the ticket system is released to. */
  requiresTicketSystem?: boolean;
}

export const INVESTOR_MENU_ITEMS: IMenuItem[] = [
  {
    id: 1,
    name: "Dashboard",
    icon: "grid_view",
    path: "/dashboard",
    isVisible: true,
    isActivated: true,
  },
  {
    id: 2,
    name: "Meine Einheiten",
    icon: "home_work",
    path: "/my-units",
    isVisible: true,
    isActivated: true,
  },
  {
    id: 3,
    name: "Finanzen",
    icon: "table_chart_view",
    path: "/financials",
    isVisible: true,
    isActivated: true,
  },
  {
    id: 4,
    name: "Verträge",
    icon: "description",
    path: "/contracts",
    isVisible: true,
    isActivated: true,
  },
  {
    id: 7,
    name: "Support",
    icon: "support_agent",
    path: "/requests",
    isVisible: true,
    requiresTicketSystem: true,
    isActivated: true,
  },
  {
    id: 5,
    name: "Knowledge Hub",
    icon: "school",
    path: "/knowledge-hub",
    isVisible: true,
    isActivated: true,
  },
  {
    id: 6,
    name: "Account",
    icon: "account_circle",
    path: "/profile",
    isVisible: false,
    isActivated: true,
  },
];

export const TENANT_MENU_ITEMS: IMenuItem[] = [
  {
    id: 1,
    name: "Dashboard",
    icon: "grid_view",
    path: "/dashboard",
    isVisible: true,
    isActivated: true,
  },
  {
    id: 2,
    name: "Your Unit",
    icon: "home",
    path: "/my-unit",
    isVisible: true,
    isActivated: true,
  },
  {
    id: 3,
    name: "Payments",
    icon: "payments",
    path: "/payments",
    isVisible: true,
    isActivated: true,
  },
  {
    id: 4,
    name: "Support",
    icon: "support_agent",
    path: "/requests",
    isVisible: true,
    requiresTicketSystem: true,
    isActivated: true,
  },
  /*{
    id: 5,
    name: "Community",
    icon: "school",
    path: "/community",
    isVisible: true,
    isActivated: true,
  },*/
  {
    id: 6,
    name: "Account",
    icon: "account_circle",
    path: "/profile",
    isVisible: false,
    isActivated: true,
  },
];
